import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Container, Spinner } from 'react-bootstrap'
import "../../styles/multipliers-styles.scss"
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import ProductMultiplierTopBar from "./Includes/ProductMultiplierTopBar"
import FormProductMultiplierTable from "./Includes/FormProductMultiplierTable"
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_CATEGORIES
} from 'utlis/AppMessages/AppMessages'
import { getCategoriesTree } from 'utlis/Apis/Categories_API'
import { toast } from 'react-toastify';
import { getProducts } from 'utlis/Apis/Products_API';
import { getMultipliers, updateProductMultiplier } from 'utlis/Apis/Multipliers_API';
import { ERROR_WHILE_FETCHING_PRODUCTS } from 'utlis/AppMessages/AppMessages';
import { Link } from 'react-router-dom';
import { ERROR_WHILE_UPDATING_PRODUCT } from 'utlis/AppMessages/AppMessages';
import { PRODUCT_MULTIPLIERS_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_FETCHING_MULTIPLIERS } from 'utlis/AppMessages/AppMessages';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';


function ProductMultiplier(props) {
    // props
    const { authState } = props

    // store url
    const [storeUrl] = useStoreUrl()

    const [column__costPrice, setColumn__costPrice] = useState(true)
    const [column__brandMultiplier, setColumn__brandMultiplier] = useState(true)
    const [column__categoryMultiplier, setColumn__categoryMultiplier] = useState(true)
    const [column__productMultiplier, setColumn__productMultiplier] = useState(true)
    const [column__shippingMultiplier, setColumn__shippingMultiplier] = useState(true)
    const [column__creditCardFee, setColumn__creditCardFee] = useState(true)
    const [column__misc, setColumn__misc] = useState(true)
    const [column__totalPrice, setColumn__totalPrice] = useState(true)
    const [column__totalProfit, setColumn__totalProfit] = useState(true)
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(true)
    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)
    const ProductsLoadingIndicator = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [products, setProducts] = useState([])
    const [multipliers, setMultipliers] = useState([])
    const [multiplier, setMultiplier] = useState({})
    const [category, setCategory] = useState("")
    const [multiplierLoading, setMultiplierLoading] = useState(false)


    useEffect(() => {
        setSectionLoadingVisible(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCategoriesTree(headers).then(res => {
            setSectionLoadingVisible(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setCategories(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_CATEGORIES, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                }
            })
        })

        getMultipliers(headers).then(res => {
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setMultiplier(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_MULTIPLIERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getMultipliers `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [authState, props, loading])

    const updateMultiplierSipping = (id, multiplier, type) => {
        const newArray = multipliers.filter(e => parseInt(e.product_id) !== parseInt(id))
        const newMultiplier = multipliers.find(e => parseInt(e.product_id) === parseInt(id))
        newMultiplier.product_id = id
        newMultiplier.shipping_multiplier = multiplier
        newMultiplier.shipping_multiplier_type = type
        //combination id

        newArray.push(newMultiplier)
        setMultipliers(newArray)
    }



    const updateMultiplier = (id, multiplier, type) => {
        const newArray = multipliers.filter(e => parseInt(e.product_id) !== parseInt(id))
        const newMultiplier = multipliers.find(e => parseInt(e.product_id) === parseInt(id))
        newMultiplier.product_id = id
        newMultiplier.multiplier = multiplier
        newMultiplier.multiplier_type = type
        //combination id

        newArray.push(newMultiplier)
        setMultipliers(newArray)
    }
    const updateMultipliers = () => {
        setMultiplierLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        updateProductMultiplier(headers, multipliers).then(res => {
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                toast.success(PRODUCT_MULTIPLIERS_UPDATED_SUCCESSFULLY, {
                    autoClose: 3000
                })
                setMultiplierLoading(false)
            }
            if (resData && resData.error) {
                toast.dismiss(
                    setMultiplierLoading(true),
                );
                toast.error(ERROR_WHILE_UPDATING_PRODUCT, {
                    autoClose: 3000,
                    onClose: () => {
                        setMultiplierLoading(false)
                    }
                })
            }
        })

    }

    const getProducts_ = (e) => {
        const category_ = e.target.value
        const URLParams = "&limit=-1"
        setCategory(category_)
        if (!category_) {
            setProducts([])
            setMultipliers([])
        } else {
            const query = "category_id=" + category_ + URLParams
            setLoading(true)
            setSectionLoadingVisible(true)
            setProducts([])
            setMultipliers([])
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            getProducts(headers, query).then(res => {
                setSectionLoadingVisible(false)
                setLoading(false)
                setMultiplierLoading(false)
                const resData = res.data
                window.scrollTo(0, 0)
                if (resData && resData.success) {
                    setProducts(resData.data)
                    const multies = []

                    resData.data.forEach(e => {
                        multies.push({
                            product_id: e.product_id,
                            multiplier: e.multiplier || 0,
                            multiplier_type: e.multiplier_type || "percent",
                            shipping_multiplier: e.shipping_multiplier,
                            shipping_multiplier_type: e.shipping_multiplier_type
                        })
                    })
                    setMultipliers(multies)
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();
                    // showing the error message
                    toast.error(ERROR_WHILE_FETCHING_PRODUCTS, {
                        autoClose: 3000,
                        onClose: () => {
                            // disabling loading
                            // setMultiplierLoading(false)
                        }
                    })
                }
            })
        }
    }

    return (
        <section id="app-multipliers" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to={storeUrl + "/catalog/multipliers"}
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Product Multiplier</p>
                        <p className="app-desc">Setup of Product Multipliers</p>
                    </div>
                    <ProductMultiplierTopBar
                        column__costPrice={column__costPrice}
                        column__brandMultiplier={column__brandMultiplier}
                        column__categoryMultiplier={column__categoryMultiplier}
                        column__productMultiplier={column__productMultiplier}
                        column__shippingMultiplier={column__shippingMultiplier}
                        column__creditCardFee={column__creditCardFee}
                        column__misc={column__misc}
                        column__totalPrice={column__totalPrice}
                        column__totalProfit={column__totalProfit}

                        setColumn__costPrice={bool => setColumn__costPrice(bool)}
                        setColumn__brandMultiplier={bool => setColumn__brandMultiplier(bool)}
                        setColumn__categoryMultiplier={bool => setColumn__categoryMultiplier(bool)}
                        setColumn__productMultiplier={bool => setColumn__productMultiplier(bool)}
                        setColumn__shippingMultiplier={bool => setColumn__shippingMultiplier(bool)}
                        setColumn__creditCardFee={bool => setColumn__creditCardFee(bool)}
                        setColumn__misc={bool => setColumn__misc(bool)}
                        setColumn__totalPrice={bool => setColumn__totalPrice(bool)}
                        setColumn__totalProfit={bool => setColumn__totalProfit(bool)}

                        categories={categories}
                        ProductsLoadingIndicator={ProductsLoadingIndicator}
                        sectionLoadingVisible={sectionLoadingVisible}
                        getProducts_={getProducts_}
                    />
                    <Col xs={12} md={12} lg={12} className="px-0">
                        {!category ? "Please select catergory" : <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block">
                                <div className="app-card">
                                    <div className="app-card-content">
                                        <Col xs={12} md={9} lg={12} className="pad-20 pt-0">
                                            <FormProductMultiplierTable
                                                column__costPrice={column__costPrice}
                                                column__brandMultiplier={column__brandMultiplier}
                                                column__categoryMultiplier={column__categoryMultiplier}
                                                column__productMultiplier={column__productMultiplier}
                                                column__shippingMultiplier={column__shippingMultiplier}
                                                column__creditCardFee={column__creditCardFee}
                                                column__misc={column__misc}
                                                column__totalPrice={column__totalPrice}
                                                column__totalProfit={column__totalProfit}

                                                setColumn__costPrice={bool => setColumn__costPrice(bool)}
                                                setColumn__brandMultiplier={bool => setColumn__brandMultiplier(bool)}
                                                setColumn__categoryMultiplier={bool => setColumn__categoryMultiplier(bool)}
                                                setColumn__productMultiplier={bool => setColumn__productMultiplier(bool)}
                                                setColumn__shippingMultiplier={bool => setColumn__shippingMultiplier(bool)}
                                                setColumn__creditCardFee={bool => setColumn__creditCardFee(bool)}
                                                setColumn__misc={bool => setColumn__misc(bool)}
                                                setColumn__totalPrice={bool => setColumn__totalPrice(bool)}
                                                setColumn__totalProfit={bool => setColumn__totalProfit(bool)}

                                                products={products}
                                                ProductsLoadingIndicator={ProductsLoadingIndicator}
                                                sectionLoadingVisible={sectionLoadingVisible}
                                                loading={loading}
                                                updateMultiplierSipping={updateMultiplierSipping}
                                                updateMultiplier={updateMultiplier}
                                                multipliers={multipliers}
                                                globleMultiplier={multiplier}
                                            />
                                            <div className="d-flex justify-content-end mt-4">
                                                <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="cats-all-btns-right d-flex flex-wrap  justify-content-start align-items-center">
                                                        <Button
                                                            className="st-btn st-btn-gray no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary me-2">
                                                            <FeatherIcon
                                                                icon="rotate-cw"
                                                                size="14"
                                                                className="icon me-2" />
                                                            <span>Reset</span>
                                                        </Button>
                                                        <Button
                                                            className={`st-btn st-btn-primary  no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary}`}
                                                            onClick={updateMultipliers}
                                                        >
                                                            {
                                                                multiplierLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : (
                                                                    <>
                                                                        <FeatherIcon
                                                                            icon="download"
                                                                            size="14"
                                                                            className="icon me-2" />

                                                                        <span>Save</span>
                                                                    </>
                                                                )}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(ProductMultiplier)